import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "about-project" }
const _hoisted_9 = { class: "content-grid" }
const _hoisted_10 = { class: "text-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "devops-deep-dive" }
const _hoisted_14 = { class: "devops-grid" }
const _hoisted_15 = { class: "tech-card" }
const _hoisted_16 = { class: "tech-header" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "tech-card" }
const _hoisted_19 = { class: "tech-header" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "tech-card full-width" }
const _hoisted_22 = { class: "tech-header" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "concrete-manifests" }
const _hoisted_25 = { class: "manifests-grid" }
const _hoisted_26 = { class: "manifest-card" }
const _hoisted_27 = { class: "manifest-header" }
const _hoisted_28 = { class: "editor-window" }
const _hoisted_29 = { class: "code-snippet-v3" }
const _hoisted_30 = { class: "y-str" }
const _hoisted_31 = { class: "manifest-desc" }
const _hoisted_32 = { class: "manifest-card" }
const _hoisted_33 = { class: "manifest-header" }
const _hoisted_34 = { class: "editor-window" }
const _hoisted_35 = { class: "code-snippet-v3" }
const _hoisted_36 = { class: "y-str" }
const _hoisted_37 = { class: "y-str" }
const _hoisted_38 = { class: "manifest-desc" }
const _hoisted_39 = { class: "manifest-card" }
const _hoisted_40 = { class: "manifest-header" }
const _hoisted_41 = { class: "manifest-desc" }
const _hoisted_42 = { class: "manifest-card" }
const _hoisted_43 = { class: "manifest-header" }
const _hoisted_44 = { class: "manifest-desc" }
const _hoisted_45 = { class: "manifest-card" }
const _hoisted_46 = { class: "manifest-header" }
const _hoisted_47 = { class: "manifest-desc" }
const _hoisted_48 = { class: "manifest-card" }
const _hoisted_49 = { class: "manifest-header" }
const _hoisted_50 = { class: "editor-window" }
const _hoisted_51 = { class: "code-snippet-v3" }
const _hoisted_52 = { class: "y-val" }
const _hoisted_53 = { class: "manifest-desc" }
const _hoisted_54 = { class: "strategy-details" }
const _hoisted_55 = { class: "tech-grid" }
const _hoisted_56 = { class: "tech-card" }
const _hoisted_57 = { class: "tech-header" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "tech-card" }
const _hoisted_60 = { class: "tech-header" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = { class: "tech-card" }
const _hoisted_63 = { class: "tech-header" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "visuals-section" }
const _hoisted_66 = { class: "visuals-grid" }
const _hoisted_67 = { class: "visual-card" }
const _hoisted_68 = { class: "image-wrapper" }
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "visual-card" }
const _hoisted_71 = { class: "image-wrapper" }
const _hoisted_72 = ["src"]
const _hoisted_73 = { class: "visual-card" }
const _hoisted_74 = { class: "image-wrapper" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "technical-details" }
const _hoisted_77 = { class: "competencies-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/image/ndi-global-page.png'),
            alt: "Logo NDI 2025",
            class: "header-image",
            loading: "lazy"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ndi.title')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('ndi.subtitle')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ndi.aboutTitle')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.about1')
          }, null, 8, _hoisted_11),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.about2')
          }, null, 8, _hoisted_12)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"highlight-box\" data-v-5ddf6d13><div class=\"stat-item\" data-v-5ddf6d13><span class=\"mdi mdi-timer-outline stat-icon\" data-v-5ddf6d13></span><span class=\"stat-text\" data-v-5ddf6d13>24h Challenge</span></div><div class=\"stat-item\" data-v-5ddf6d13><span class=\"mdi mdi-api stat-icon\" data-v-5ddf6d13></span><span class=\"stat-text\" data-v-5ddf6d13>API-First Design</span></div><div class=\"stat-item\" data-v-5ddf6d13><span class=\"mdi mdi-infinity stat-icon\" data-v-5ddf6d13></span><span class=\"stat-text\" data-v-5ddf6d13>Full GitOps</span></div></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ndi.infraTitle')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mdi mdi-rocket-launch-outline tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.gitopsTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.gitopsDesc')
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mdi mdi-layers-triple-outline tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.k8sTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.k8sDesc')
          }, null, 8, _hoisted_20)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-sync tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.automationTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.automationDesc')
          }, null, 8, _hoisted_23)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_24, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ndi.concreteTitle')), 1),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mdi mdi-auto-fix" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title1')), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>applicationset.yaml</span></div>", 1)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("pre", null, [
                _createElementVNode("code", null, [
                  _cache[5] || (_cache[5] = _createStaticVNode("<span class=\"y-comment\" data-v-5ddf6d13># Generator for GitLab MRs</span>\n<span class=\"y-key\" data-v-5ddf6d13>generators</span>:\n  - <span class=\"y-key\" data-v-5ddf6d13>pullRequest</span>:\n      <span class=\"y-key\" data-v-5ddf6d13>gitlab</span>:\n        <span class=\"y-key\" data-v-5ddf6d13>project</span>: <span class=\"y-str\" data-v-5ddf6d13>ndi-2025/api</span>\n        <span class=\"y-key\" data-v-5ddf6d13>tokenRef</span>: {<span class=\"y-key\" data-v-5ddf6d13>name</span>: <span class=\"y-str\" data-v-5ddf6d13>token</span>, <span class=\"y-key\" data-v-5ddf6d13>key</span>: <span class=\"y-str\" data-v-5ddf6d13>token</span>}\n<span class=\"y-key\" data-v-5ddf6d13>template</span>:\n  <span class=\"y-key\" data-v-5ddf6d13>spec</span>:\n    <span class=\"y-key\" data-v-5ddf6d13>source</span>:\n      <span class=\"y-key\" data-v-5ddf6d13>targetRevision</span>: ", 30)),
                  _createElementVNode("span", _hoisted_30, "\"" + _toDisplayString(_ctx.branch) + "\"", 1),
                  _cache[6] || (_cache[6] = _createTextVNode("\n      ")),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "y-key" }, "path", -1)),
                  _cache[8] || (_cache[8] = _createTextVNode(": ")),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "y-str" }, "k8s/overlays/preview", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('ndi.manifests.desc1')), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mdi mdi-vector-point" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title2')), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>kustomization.yaml</span></div>", 1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("pre", null, [
                _createElementVNode("code", null, [
                  _cache[12] || (_cache[12] = _createStaticVNode("<span class=\"y-comment\" data-v-5ddf6d13># Dynamic Hostname Patch</span>\n- <span class=\"y-key\" data-v-5ddf6d13>target</span>:\n    <span class=\"y-key\" data-v-5ddf6d13>kind</span>: <span class=\"y-str\" data-v-5ddf6d13>IngressRoute</span>\n  <span class=\"y-key\" data-v-5ddf6d13>patch</span>: <span class=\"y-val\" data-v-5ddf6d13>|-</span>\n    <span class=\"y-str\" data-v-5ddf6d13>- op: replace</span>\n    <span class=\"y-str\" data-v-5ddf6d13>  path: /spec/routes/0/match</span>\n    ", 16)),
                  _createElementVNode("span", _hoisted_36, "  value: Host(`api-mr-" + _toDisplayString(_ctx.number) + ".ndi.com`)", 1),
                  _cache[13] || (_cache[13] = _createStaticVNode("\n\n<span class=\"y-comment\" data-v-5ddf6d13># Dynamic DB Name</span>\n- <span class=\"y-key\" data-v-5ddf6d13>target</span>: {<span class=\"y-key\" data-v-5ddf6d13>kind</span>: <span class=\"y-str\" data-v-5ddf6d13>ConfigMap</span>}\n  <span class=\"y-key\" data-v-5ddf6d13>patch</span>: <span class=\"y-val\" data-v-5ddf6d13>|-</span>\n    <span class=\"y-str\" data-v-5ddf6d13>- op: replace</span>\n    <span class=\"y-str\" data-v-5ddf6d13>  path: /data/DB_NAME</span>\n    ", 17)),
                  _createElementVNode("span", _hoisted_37, "  value: ndi_mr" + _toDisplayString(_ctx.number), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('ndi.manifests.desc2')), 1)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mdi mdi-heart-pulse" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title3')), 1)
          ]),
          _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"editor-window\" data-v-5ddf6d13><div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>deployment.yaml</span></div><div class=\"code-snippet-v3\" data-v-5ddf6d13><pre data-v-5ddf6d13><code data-v-5ddf6d13><span class=\"y-key\" data-v-5ddf6d13>containers</span>:\n  - <span class=\"y-key\" data-v-5ddf6d13>name</span>: <span class=\"y-str\" data-v-5ddf6d13>ndi-api</span>\n    <span class=\"y-key\" data-v-5ddf6d13>readinessProbe</span>:\n      <span class=\"y-key\" data-v-5ddf6d13>httpGet</span>: {<span class=\"y-key\" data-v-5ddf6d13>path</span>: <span class=\"y-str\" data-v-5ddf6d13>/system</span>, <span class=\"y-key\" data-v-5ddf6d13>port</span>: <span class=\"y-val\" data-v-5ddf6d13>6000</span>}\n      <span class=\"y-key\" data-v-5ddf6d13>initialDelaySeconds</span>: <span class=\"y-val\" data-v-5ddf6d13>10</span>\n    <span class=\"y-key\" data-v-5ddf6d13>livenessProbe</span>:\n      <span class=\"y-key\" data-v-5ddf6d13>httpGet</span>: {<span class=\"y-key\" data-v-5ddf6d13>path</span>: <span class=\"y-str\" data-v-5ddf6d13>/system</span>, <span class=\"y-key\" data-v-5ddf6d13>port</span>: <span class=\"y-val\" data-v-5ddf6d13>6000</span>}\n    <span class=\"y-key\" data-v-5ddf6d13>resources</span>:\n      <span class=\"y-key\" data-v-5ddf6d13>requests</span>:\n        <span class=\"y-key\" data-v-5ddf6d13>cpu</span>: <span class=\"y-str\" data-v-5ddf6d13>100m</span>\n        <span class=\"y-key\" data-v-5ddf6d13>memory</span>: <span class=\"y-str\" data-v-5ddf6d13>256Mi</span></code></pre></div></div>", 1)),
          _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('ndi.manifests.desc3')), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "mdi mdi-shield-key-outline" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title4')), 1)
          ]),
          _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"editor-window\" data-v-5ddf6d13><div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>sealed-secret.yaml</span></div><div class=\"code-snippet-v3\" data-v-5ddf6d13><pre data-v-5ddf6d13><code data-v-5ddf6d13><span class=\"y-key\" data-v-5ddf6d13>kind</span>: <span class=\"y-str\" data-v-5ddf6d13>SealedSecret</span>\n<span class=\"y-key\" data-v-5ddf6d13>spec</span>:\n  <span class=\"y-key\" data-v-5ddf6d13>encryptedData</span>:\n    <span class=\"y-key\" data-v-5ddf6d13>token</span>: <span class=\"y-str\" data-v-5ddf6d13>AgCDo1oTCVNud0KjUxtoy...</span>\n<span class=\"y-key\" data-v-5ddf6d13>template</span>:\n  <span class=\"y-key\" data-v-5ddf6d13>metadata</span>:\n    <span class=\"y-key\" data-v-5ddf6d13>name</span>: <span class=\"y-str\" data-v-5ddf6d13>gitlab-token</span>\n    <span class=\"y-key\" data-v-5ddf6d13>namespace</span>: <span class=\"y-str\" data-v-5ddf6d13>argocd</span></code></pre></div></div>", 1)),
          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('ndi.manifests.desc4')), 1)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mdi mdi-shield-outline" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title5')), 1)
          ]),
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"editor-window\" data-v-5ddf6d13><div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>middleware.yaml</span></div><div class=\"code-snippet-v3\" data-v-5ddf6d13><pre data-v-5ddf6d13><code data-v-5ddf6d13><span class=\"y-key\" data-v-5ddf6d13>kind</span>: <span class=\"y-str\" data-v-5ddf6d13>Middleware</span>\n<span class=\"y-key\" data-v-5ddf6d13>spec</span>:\n  <span class=\"y-key\" data-v-5ddf6d13>headers</span>:\n    <span class=\"y-key\" data-v-5ddf6d13>accessControlAllowMethods</span>:\n      - <span class=\"y-str\" data-v-5ddf6d13>GET</span>, <span class=\"y-str\" data-v-5ddf6d13>POST</span>, <span class=\"y-str\" data-v-5ddf6d13>PUT</span>, <span class=\"y-str\" data-v-5ddf6d13>DELETE</span>\n    <span class=\"y-key\" data-v-5ddf6d13>accessControlAllowOriginList</span>:\n      - <span class=\"y-str\" data-v-5ddf6d13>&quot;*&quot;</span>\n    <span class=\"y-key\" data-v-5ddf6d13>accessControlAllowCredentials</span>: <span class=\"y-val\" data-v-5ddf6d13>true</span></code></pre></div></div>", 1)),
          _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t('ndi.manifests.desc5')), 1)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "mdi mdi-update" }, null, -1)),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ndi.manifests.title6')), 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"editor-header\" data-v-5ddf6d13><div class=\"dots\" data-v-5ddf6d13><span class=\"r\" data-v-5ddf6d13></span><span class=\"y\" data-v-5ddf6d13></span><span class=\"g\" data-v-5ddf6d13></span></div><span class=\"file-name\" data-v-5ddf6d13>annotations.yaml</span></div>", 1)),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("pre", null, [
                _createElementVNode("code", null, [
                  _cache[22] || (_cache[22] = _createStaticVNode("<span class=\"y-key\" data-v-5ddf6d13>annotations</span>:\n  <span class=\"y-key\" data-v-5ddf6d13>argocd-image-updater.../image-list</span>: <span class=\"y-str\" data-v-5ddf6d13>ndi-api</span>\n  <span class=\"y-key\" data-v-5ddf6d13>argocd-image-updater.../strategy</span>: <span class=\"y-str\" data-v-5ddf6d13>newest-build</span>\n  <span class=\"y-key\" data-v-5ddf6d13>argocd-image-updater.../allow-tags</span>: ", 12)),
                  _createElementVNode("span", _hoisted_52, "regexp:^preview-mr" + _toDisplayString(_ctx.number) + "-.*", 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('ndi.manifests.desc6')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_54, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ndi.techTitle')), 1),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "mdi mdi-file-code-outline tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.apiFirstTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.apiFirstDesc')
          }, null, 8, _hoisted_58)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "mdi mdi-leaf tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.backendTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.backendDesc')
          }, null, 8, _hoisted_61)
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "mdi mdi-react tech-icon" }, null, -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ndi.frontendTitle')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('ndi.frontendDesc')
          }, null, 8, _hoisted_64)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_65, [
      _cache[30] || (_cache[30] = _createElementVNode("h2", null, "Project Previews", -1)),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Global Interface", -1)),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("img", {
              src: require('@/assets/image/ndi-global-page.png'),
              alt: "NDI Global Page",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_69)
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Post Management", -1)),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("img", {
              src: require('@/assets/image/ndi-post-page.png'),
              alt: "NDI Post Page",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_72)
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Personal Profile", -1)),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("img", {
              src: require('@/assets/image/ndi-me-page.png'),
              alt: "NDI Me Page",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_75)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_76, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('ndi.learningsTitle')), 1),
      _createElementVNode("div", _hoisted_77, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-api",
          title: "API-First",
          description: _ctx.$t('ndi.learning1')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-sync",
          title: "GitOps Preview",
          description: _ctx.$t('ndi.learning2')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-docker",
          title: "Multi-Arch CI",
          description: _ctx.$t('ndi.learning3')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-timer-flash-outline",
          title: "Rapid Delivery",
          description: _ctx.$t('ndi.learning4')
        }, null, 8, ["description"])
      ])
    ])
  ]))
}